import React from 'react';
import { DollarSign, Users2, Building2, Store, Megaphone } from 'lucide-react';

const Features = () => {
  const features = [
    {
      title: "Smart Payroll Management",
      icon: <DollarSign className="w-8 h-8" />,
      description:
        "Automate your entire payroll process with intelligent calculations, tax handling, and direct deposits.",
      subFeatures: [
        "Multi-currency support",
        "Automated tax calculations",
        "Custom payment schedules",
      ],
      gradient: "from-[#732570] to-purple-600",
    },
    {
      title: "Comprehensive Staff Management",
      icon: <Users2 className="w-8 h-8" />,
      description:
        "Streamline your workforce management with powerful tools for scheduling, performance tracking, and development.",
      subFeatures: [
        "Performance analytics",
        "Training management",
        "Shift scheduling",
      ],
      gradient: "from-blue-600 to-cyan-500",
    },
    {
      title: "Enterprise Company Solutions",
      icon: <Building2 className="w-8 h-8" />,
      description:
        "Scale your business operations with integrated tools for compliance, reporting, and strategic planning.",
      subFeatures: [
        "Compliance monitoring",
        "Department analytics",
        "Resource allocation",
      ],
      gradient: "from-emerald-500 to-teal-400",
    },
    {
      title: "Small Business Growth Tools",
      icon: <Store className="w-8 h-8" />,
      description:
        "Empower your small business with affordable, scalable solutions for sustainable growth.",
      subFeatures: [
        "Budget forecasting",
        "Growth analytics",
        "Business planning",
      ],
      gradient: "from-amber-500 to-orange-400",
    },
    {
      title: "Integrated Marketing Hub",
      icon: <Megaphone className="w-8 h-8" />,
      description:
        "Drive business success with comprehensive marketing tools and analytics.",
      subFeatures: [
        "Campaign tracking",
        "ROI analytics",
        "Market insights",
      ],
      gradient: "from-rose-500 to-pink-500",
    },
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
          <div className="head">
            <div className="text-left mb-8 md:mb-0">
              <small className="text-primary-600 uppercase tracking-wide">
                Features
              </small>
              <div className="border-t-4 border-primary-500 w-16 mt-2 mb-6"></div>
              <h2 className="text-6xl font-bold text-gray-900 mb-6">
                <span className="relative inline-block">Power Your Business</span>
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Unlock your business potential with our comprehensive suite of tools
                designed for modern enterprises
              </p>
            </div>
          </div>
          {features.map((feature, index) => (
            <div
              key={index}
              className="relative group bg-white py-8 px-8 h-[350px] transition-all duration-300 overflow-hidden border border-gray-200"
            >
              <div
                className={`absolute inset-0 bg-gradient-to-br ${feature.gradient} opacity-0 group-hover:opacity-5 transition-opacity duration-300`}
              ></div>

              <div className="flex items-center mb-6">
                <div
                  className={`w-16 h-16 rounded-xl bg-gradient-to-br ${feature.gradient} flex flex-shrink-0 items-center justify-center text-white mr-6 group-hover:scale-110 transition-transform duration-300`}
                >
                  {feature.icon}
                </div>

                <h3 className="text-lg md:text-2xl font-bold text-gray-900">
                  {feature.title}
                </h3>
              </div>

              <p className="text-gray-600 mb-6">{feature.description}</p>

              <div className="space-y-3">
                {feature.subFeatures.map((subFeature, subIndex) => (
                  <div key={subIndex} className="flex items-center text-gray-700">
                    <div
                      className={`w-2 h-2 rounded-full bg-gradient-to-br ${feature.gradient} mr-3`}
                    ></div>
                    <span>{subFeature}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;